export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_64_SITE': 'Site',
    '_67_SUPERGROUP': 'SuperGroup',
    '_148_AREA': 'Area',
    '_149_REGION': 'Region',
    '_583_LOB': 'LOB',
    '_725_ACTUAL': 'Actual',
    '_726_TARGET': 'Target',
    '_768___TO_TARGET': '% to Target',
    '_797_OPPORTUNITY_ALIGNMENT': 'Opportunity Alignment',
    '_824_PEER_GROUP': 'PeerGroup',
    '_828_MONTH': 'Month',
    '_4105_PREVIOUS_ACTUAL': 'Previous Actual',
    '_7463_OA': 'OA',
    '_9251_MY': 'My',
    '_4000_MY_OA': 'My OA',
    '_9904_MY_AREA': 'My Area',
    '_9905_MY_LOB': 'My LOB',
    '_9906_MY_PEERGROUP': 'My PeerGroup',
    '_9907_MY_REGION': 'My Region',
    '_9908_MY_SITE': 'My Site',
    '_9909_MY_SUPERGROUP': 'My SuperGroup',
    '_9910_AREA_OA': 'Area OA',
    '_9911_LOB_OA': 'LOB OA',
    '_9912_PEERGROUP_OA': 'PeerGroup OA',
    '_9913_REGION_OA': 'Region OA',
    '_9914_SITE_OA': 'Site OA',
    '_9915_SUPERGROUP_OA': 'SuperGroup OA',
    '_9603_OTHER': 'Other',
    '_9916_MY_COACHING': 'My Coaching',
    '_9917_LAUNCH_OA': 'Launch OA',
    '_9918_PEER_COMPARE': 'Peer Compare',
    '_9920_COACHED_OPPORTUNITY': 'Coached Opportunity',
    '_9921_UNCOACHED_OPPORTUNITY': 'Uncoached Opportunity',
    '_9922_EXPECTED_OPPORTUNITY': 'Expected Opportunity',
    '_9923_LAST_UPDATED': 'Last Updated',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_798_MI2': 'MI2',
    '_9402_NA': 'NA',
    '_9872_SCORECARD_HISTORY': 'Scorecard History',
    '_9866_NO_MI2_DATA_AVAILABLE': 'No MI2 Data Available',
    '_10073_OPPORTUNITY_ALIGNMENT_TREND': 'Opportunity Alignment Trend',
    '_10074_MI2_TREND': 'MI2 Trend',
    '_10075_VIEW_TREND': 'View Trend',
    '_10076_CLOSE_TREND': 'Close Trend',
    '_9854_OA_SCORE': 'OA Score',
    '_9878_MI2_SCORE': 'MI2 Score',
    '_9845_FRONT_LINE_OA': 'Front Line OA',
    '_4005_FLOA__': 'FLOA',
    '_10077_FRONT_LINE_OA_TREND': 'Front Line OA trend',
    '_10078_FLOA_Score': 'FLOA Score',
    '_7372_TOTAL_OPPORTUNITIES': 'Total Opportunities',
    '_7427_EXPECTED_OPPORTUNITIES': 'Expected Opportunities',
    '_7481_FUNDED_COACHED_OPPORTUNITIES': 'Funded Coached Opportunities',
    '_7493_TOTAL_AGENTS': 'Total Agents',
    '_7494___OF_AGENTS_WITH_OPPORTUNITIES': '% of Agents with Opportunities',
    '_10103_TOTAL_EVENTS': 'Total Events',
    '_10104_NUMBER_WINNING': 'Number Winning',
    '_10098_NUMBER_LOSING': 'Number Losing',
    '_10099_NUMBER_NEUTRAL': 'Number Neutral',
    '_10080_COACHING_EVENT_RANGE': 'Coaching Event Range',
    '_10082_EVALUATION_RANGE': 'Evaluation Range',
    '_10094_WINNING__': 'Winning %',
    '_10100_WINNING__TREND': 'Winning % Trend',
    '_10101_WINNING__SCORE': 'Winning % Score',
    '_10102_NO_WINNING__DATA_AVAILABLE': 'No Winning % Data Available',
    '_11118_FRONT_LINE_MI2': 'Front Line Mi2',
    '_11119_FLMI2_SCORE': 'FLMI2 Score',
    '_11120_FLMI2_TREND': 'FLMI2 Trend',
    '_11080_FRONT_LINE_WINNING__': 'Front Line Winning %',
    '_11166_NO_FRONT_LINE_WINNING__DATA_AVAILABLE': 'No Front Line Winning % Data Available',
    '_11167_FLWP_SCORE': 'FLWP Score',
    '_11168_FLWP_TREND': 'FLWP Trend'
};
